namespace InvData.Util.DateIndexHelper {

    export var _daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    export var _daysInMonthsLeapYear = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    export var _monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    export var _monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    export const _paMinDateId = 0;
    export const _paMaxDateId = 91310;

    export function _isLeapYear(year: number): boolean {
        if ((year % 400) == 0) {
            return true;
        }
        else if ((year % 100) == 0) {
            return false;
        }
        else if ((year % 4) == 0) {
            return true;
        }
        else {
            return false;
        }
    }

    export function _daysInYear(year: number): number {
        if (DateIndexHelper._isLeapYear(year)) {
            return 366;
        }
        else {
            return 365;
        }
    }

    export function getDaysInMonth(dateOrDateIndex: Date | number): number {
        var date;
        if (dateOrDateIndex instanceof Date) {
            date = dateOrDateIndex;
        }
        else {
            date = DateIndexHelper.getDateFromDateIndex(dateOrDateIndex);
        }

        var year = date.getFullYear();
        var month = date.getMonth();

        var dayCountsToUse;
        if (DateIndexHelper._isLeapYear(year)) {
            dayCountsToUse = DateIndexHelper._daysInMonthsLeapYear;
        }
        else {
            dayCountsToUse = DateIndexHelper._daysInMonths;
        }

        var daysInMonth = dayCountsToUse[month];
        return daysInMonth;
    }

    export function isLastDayInMonth(dateOrDateIndex: Date | number): boolean {
        var date;
        if (dateOrDateIndex instanceof Date) {
            date = dateOrDateIndex;
        }
        else {
            date = DateIndexHelper.getDateFromDateIndex(dateOrDateIndex);
        }

        var day = date.getDate();

        var daysInMonth = DateIndexHelper.getDaysInMonth(date);

        return day == daysInMonth;
    }

    export function isValidDateIndex(dateIndex: number): boolean {
       return typeof dateIndex !== 'undefined' && dateIndex >= this._paMinDateId && dateIndex <= this._paMaxDateId;
    }

    export function getDateIndexFromDate(date: Date): number {
        // TODO: Replace with method that does not need to count through the years.
        return DateIndexHelper.getDateIndexFromDateUsingSlowMethod(date);
    }

    export function getDateIndexFromDateUsingSlowMethod(date: Date): number {
        if (!date) {
            return null;
        }

        var year = date.getFullYear();
        if (year < 1900) {
            throw "Years less than 1900 are not supported.";
        }
        else if (year > 2200) {
            throw "Years greater than 2200 are not supported.";
        }

        var days = 0;

        var yearCo = 1900;
        while (yearCo < year) {
            days += DateIndexHelper._daysInYear(yearCo);
            yearCo++;
        }

        var month = date.getMonth();
        var dayOfMonth = date.getDate();

        var daysInMonthToUse = DateIndexHelper._isLeapYear(year) ? DateIndexHelper._daysInMonthsLeapYear : DateIndexHelper._daysInMonths;

        var monthCo = 0;
        while (monthCo < month) {
            days += daysInMonthToUse[monthCo];
            monthCo++;
        }

        days += (dayOfMonth - 1);

        return days;
    }

    export function getTodayLastYear(): Date {
        let now = new Date();
        let month = now.getMonth();
        let day = now.getDate();
        if (month == 1 && day == 29) {
            day--;
        }

        return new Date(now.getFullYear() - 1, month, day);
    }

    export function getDateIndexForToday(): number {
        return DateIndexHelper.getDateIndexFromDate(new Date());
    }

    export function getDateFromDateIndex(dateIndex: number): Date {
        // TODO: Check for null too?
        if (dateIndex == undefined) {
            return null;
        }

        // TODO: Replace with method that does not need to count through the years.
        return DateIndexHelper.getDateFromDateIndexUsingSlowMethod(dateIndex);
    }

    export function getDateFromDateIndexUsingSlowMethod(dateIndex: number): Date {
        if (dateIndex < 0) {
            throw "Date indexes less than 0 are not supported (year 1899 and before).";
        }
        else if (dateIndex > 91310) {
            throw "Date indexes greater than 91310 are not supported (year 2150 and beyond).";
        }

        var days = 0;

        var year = 1900;

        while (true) {
            var daysInYear = DateIndexHelper._daysInYear(year);
            var daysAfterThisYear = days + daysInYear;
            if (daysAfterThisYear >= dateIndex) {
                break;
            }

            days = daysAfterThisYear;
            year++;
        }

        var daysInMonthToUse = DateIndexHelper._isLeapYear(year) ? DateIndexHelper._daysInMonthsLeapYear : DateIndexHelper._daysInMonths;

        var month = 0;

        while (true) {
            var daysInMonth = daysInMonthToUse[month];
            var daysAfterThisMonth = days + daysInMonth;
            if (daysAfterThisMonth >= dateIndex) {
                break;
            }

            days = daysAfterThisMonth;
            month++;
        }

        return new Date(year, month, 1 + (dateIndex - days));
    }

    export function formatDateAsString(date: Date): string {
        // TODO: Check for null too?
        if (date == undefined) {
            return "";
        }

        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();

        var dateStr = year.toString() + "-" + ((month < 10) ? ("0" + month) : month) + "-" + ((day < 10) ? ("0" + day) : day);
        return dateStr;
    }

    export function formatDateIndexAsDateString(dateIndex: number): string {

        if (dateIndex < this._paMinDateId || dateIndex > this._paMaxDateId) {
            return "Invalid Date. DayId: " + dateIndex;
        }

        var date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        return DateIndexHelper.formatDateAsString(date);
    }

    export function getDateOfLastDayInMonth(dateOrDateIndex: Date | number): Date {
        var date;
        if (typeof dateOrDateIndex === "number") {
            date = DateIndexHelper.getDateFromDateIndex(dateOrDateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        // TODO: Check for null too?
        if (date == undefined) {
            return null;
        }

        var year = date.getFullYear();
        var daysInMonthToUse = DateIndexHelper._isLeapYear(year) ? DateIndexHelper._daysInMonthsLeapYear : DateIndexHelper._daysInMonths;
        var month = date.getMonth();

        return new Date(year, month, daysInMonthToUse[month]);
    }

    export function getDateIndexOfLastDayInMonth(dateOrDateIndex: Date | number): number {
        var lastDayOfMonth = DateIndexHelper.getDateOfLastDayInMonth(dateOrDateIndex);
        var dayId = DateIndexHelper.getDateIndexFromDate(lastDayOfMonth);
        return dayId;
    }

    export function getDateIndexOfLastDayInPreviousMonth(dateOrDateIndex: Date | number): number {
        var date;
        var dateIndex;
        if (typeof dateOrDateIndex == "number") {
            dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
            dateIndex = DateIndexHelper.getDateIndexFromDate(date);
        }

        var dayOfMonth = date.getDate();
        var lastDayOfPrevMonth = dateIndex - dayOfMonth;

        return lastDayOfPrevMonth;
    }

    export function getDateIndexOfLastDayInPreviousQuarter(dateOrDateIndex: Date | number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        var year = date.getFullYear();
        var month = date.getMonth();

        // Determine first day of quarter. Get the date index and go back one day.
        if (month <= 2) {
            month = 0;
        }
        else if (month <= 5) {
            month = 3;
        }
        else if (month <= 8) {
            month = 6;
        }
        else if (month <= 11) {
            month = 9;
        }

        var firstDayDate = new Date(year, month, 1);

        var firstDayDayIndex = DateIndexHelper.getDateIndexFromDate(firstDayDate);
        var prevQuarterEndDayId = firstDayDayIndex - 1;
        return prevQuarterEndDayId;
    }

    export function getDateIndexOfLastDayInQuarter(dateOrDateIndex: Date | number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        var year = date.getFullYear();
        var month = date.getMonth();

        // Determine first day of quarter. Get the date index and go back one day.
        if (month <= 2) {
            month = 0;
        }
        else if (month <= 5) {
            month = 3;
        }
        else if (month <= 8) {
            month = 6;
        }
        else if (month <= 11) {
            month = 9;
        }

        var firstDayDate = new Date(year, month + 3, 1);

        var firstDayDayIndex = DateIndexHelper.getDateIndexFromDate(firstDayDate);
        var quarterEndDayId = firstDayDayIndex - 1;
        return quarterEndDayId;
    }

    export function getDateIndexOfLastDayInPreviousYear(dateOrDateIndex: Date | number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        var year = date.getFullYear();

        var endOfLastYear = new Date(year - 1, 11, 31);
        return DateIndexHelper.getDateIndexFromDate(endOfLastYear);
    }

    export function getDateIndexOfLastDayInYear(dateOrDateIndex: Date | number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        var year = date.getFullYear();

        var endOfLastYear = new Date(year, 11, 31);
        return DateIndexHelper.getDateIndexFromDate(endOfLastYear);
    }

    export function getMonthNameForMonthOffset(monthOffset: number) {
        return this._monthNames[monthOffset]; 
    }

    export function formatDateAsMonthNameYearString(date: Date): string {
        return this._monthNames[date.getMonth()] + " " + date.getFullYear();
    }

    export function formatAsShortMonthNameYear(dateOrDateIndex: Date | number): string {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }   

        return this._monthShortNames[date.getMonth()] + " " + date.getFullYear();
    }

    export function formatAsShortMonthDayYear(dateOrDateIndex: Date | number): string {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }        

        return this._monthShortNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
    }

    export function formatAsQuarterYearString(dateOrDateIndex: Date | number): string {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        // quarter year
        var quarter = (1 + (Math.floor(date.getMonth() / 3))).toString();
        return quarter + "Q " + date.getFullYear().toString();
    }


    /**
     * Retrieve last day in the fiscal year.
     * @param dateOrDateIndex
     * @param fiscalYearStartMonth - January = 1
     */
    export function getDateIndexOfLastDayInFiscalYear(dateOrDateIndex: Date | number, fiscalYearStartMonth: number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        let year = date.getFullYear();
        let monthNumber = 1 + date.getMonth();
        if (fiscalYearStartMonth === 1) {
            // We're going to go forward.
            let endDate = new Date(year, 11, 31);
            let endDayId = getDateIndexFromDate(endDate);
            return endDayId;
        }
        else {            
            let fiscalYearStartMonthOffset = fiscalYearStartMonth - 1;
            if (monthNumber >= fiscalYearStartMonth) {
                // Going forward into next year.
                let endMonthFirstDay = new Date(year + 1, fiscalYearStartMonthOffset - 1, 1);
                let endDate = new Date(endMonthFirstDay.getFullYear(), endMonthFirstDay.getMonth(), DateIndexHelper.getDaysInMonth(endMonthFirstDay));
                let endDayId = getDateIndexFromDate(endDate);
                return endDayId;
            }
            else {
                // Stop this year.
                let endMonthFirstDay = new Date(year, fiscalYearStartMonthOffset - 1, 1);
                let endDate = new Date(endMonthFirstDay.getFullYear(), endMonthFirstDay.getMonth(), DateIndexHelper.getDaysInMonth(endMonthFirstDay));
                let endDayId = getDateIndexFromDate(endDate);
                return endDayId;
            }
        }
    }

    /**
     * Retrieve last day in the previous fiscal year.
     * @param dateOrDateIndex
     * @param fiscalYearStartMonth - January = 1
     */
    export function getDateIndexOfLastDayInPreviousFiscalYear(dateOrDateIndex: Date | number, fiscalYearStartMonth: number): number {
        var date;
        if (typeof dateOrDateIndex === "number") {
            var dateIndex = dateOrDateIndex;
            date = DateIndexHelper.getDateFromDateIndex(dateIndex);
        }
        else {
            date = dateOrDateIndex;
        }

        let year = date.getFullYear();
        let monthNumber = 1 + date.getMonth();
        if (fiscalYearStartMonth === 1) {
            // We're going to directly to end of last year.
            let endDate = new Date(year - 1, 11, 31);
            let endDayId = getDateIndexFromDate(endDate);
            return endDayId;
        }
        else {
            let fiscalYearStartMonthOffset = fiscalYearStartMonth - 1;
            if (monthNumber >= fiscalYearStartMonth) {
                // Stop this year.
                let endMonthFirstDay = new Date(year, fiscalYearStartMonthOffset - 1, 1);
                let endDate = new Date(endMonthFirstDay.getFullYear(), endMonthFirstDay.getMonth(), DateIndexHelper.getDaysInMonth(endMonthFirstDay));
                let endDayId = getDateIndexFromDate(endDate);
                return endDayId;
            }
            else {
                // Stop the prior year.
                let endMonthFirstDay = new Date(year - 1, fiscalYearStartMonthOffset - 1, 1);
                let endDate = new Date(endMonthFirstDay.getFullYear(), endMonthFirstDay.getMonth(), DateIndexHelper.getDaysInMonth(endMonthFirstDay));
                let endDayId = getDateIndexFromDate(endDate);
                return endDayId;
            }
        }
    }


    export function countMonths(fromDayId: number, toDayId: number, excludePartialMonths?: boolean) {
        if (fromDayId && toDayId) {
            if (fromDayId == toDayId) {
                return 0;
            }

            let isNegative = false;
            if (fromDayId > toDayId) {
                isNegative = true;
                let holder = fromDayId;
                fromDayId = toDayId;
                toDayId = holder;
            }

            let monthCount = 0;
            let firstMonthEndDayd = InvData.DayId.forDateIndex(fromDayId, InvData.RelativeDate.MonthEnd, 0);
            let lastMonthEndDayId = InvData.DayId.forDateIndex(toDayId, InvData.RelativeDate.MonthEnd, 0);

            if (fromDayId < firstMonthEndDayd) {
                if (!excludePartialMonths) {
                    monthCount++;
                }
            }

            // Really big cut off to stop inadvertent bad data request causing near-infinite loop.
            let maxMonthCount = 30000;

            let nextMonthEndDayId = InvData.DayId.forDateIndex(firstMonthEndDayd, InvData.RelativeDate.MonthEnd, 1);
            while (nextMonthEndDayId <= lastMonthEndDayId) {
                if (!excludePartialMonths) {
                    monthCount++;
                }
                else if (toDayId >= nextMonthEndDayId) {
                    monthCount++;
                }

                if (monthCount > maxMonthCount) {
                    return null;
                }

                nextMonthEndDayId = InvData.DayId.forDateIndex(nextMonthEndDayId, InvData.RelativeDate.MonthEnd, 1);
            }

            return isNegative ? -monthCount : monthCount;
        }
        else {
            return null;
        }
    }
}     
